module.exports = __webpack_public_path__ + "static/media/distribuicao-subheader.1026d7e9.jpg";